import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
  setCurrentModal,
  MODAL_SELECT_STORE,
} from 'stores/reducers/store-selection-modal';
import MapIcon from '../../../svg/MapIcon';

const storeSelector = (state) => state.storeSelection;

const StoreSelection = () => {
  const dispatch = useDispatch();
  const selectedStoreFromState = useSelector(storeSelector);

  return (
    <div className="text-uppercase pb-10 pb-xl-15">
      <p className="font-roboto fw-600 text-grey-darker fs-6 mb-4">
        you&apos;re shopping
      </p>
      <Button
        data-value="selected-store-link"
        variant="none"
        type="button"
        className="p-0"
        onClick={() => dispatch(setCurrentModal(MODAL_SELECT_STORE))}
      >
        <MapIcon color="#1E154C" />
        <span className="font-sofia fs-8 fw-700 text-primary text-uppercase">
          {selectedStoreFromState || 'Select a Store'}
        </span>
      </Button>
    </div>
  );
};

export default StoreSelection;
